export const clearLS = () => {

    localStorage.removeItem("apiPerso.preferencias.obtener");
    localStorage.removeItem("apiPerso.preferencias.obtenerNovedades");
    localStorage.removeItem("apiPerso.preferencias.obtenerPreferibles");

    localStorage.removeItem("apiPerso.ranking.obtenerMasSeguidos");

    localStorage.removeItem("obtenerPorPrioridad");
    localStorage.removeItem("obtenerNovedades");
    localStorage.removeItem("recomendarTemas");
    localStorage.removeItem("obtenerAccesos");
    localStorage.removeItem("obtenerSugerencias");
    localStorage.removeItem("obtenerHashSuscripciones");
    localStorage.removeItem("obtenerPreferibles");
    localStorage.removeItem("notasUltimasNoticias");
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/ClearLoQueSigo.js